import {resetRouter } from '../router'
/**
  * 合并远程路由到本地路由
  * @param: subList [Array] 远程路由列表
  * @param: routes [Array] 本地路由列表
  * */
 export function mergeRoutes(subs) {
	
//	console.log(subs);
	
	let str1,str2,str3,str4 = [];
	
	if(subs){
		
					
		for (let i = 0; i < subs.length; i++) {
			str3 = [];
			
			//如果还有下一层先进去
			if(subs[i].children && subs[i].children.length > 0){
				let list1 = subs[i].children;
				
				for(let x = 0; x < list1.length; x++){
					str2 = [];
					if(list1[x].external == "1" ){//说明是外部链接，需要自己拼装
						
						//如果path=/blank，说明是空白页，需要另外处理
						if(list1[x].path == '/blank'){
							
							let temp = {
										path : list1[x].path,
										name : list1[x].name,
										menuShow : list1[x].menuShow == '1'? true: false,
										component: () => import(`@/views/nav/leftNav`),
										iconCls: list1[x].iconCls,
										meta: {
											apiActiveMenu : list1[x].meta
										},
										leaf: list1[x].leaf == '1'? true: false,
										children: [
											{
												path : list1[x].path,
												name : list1[x].name,
												menuShow : list1[x].menuShow == '1'? true: false,
												component: () => import(`@/views${list1[x].component}`),
										
											}
										],
									}; 
									
							str3.push(temp);
						}else{
							let temp = {
										path : list1[x].path,
										name : list1[x].name,
										menuShow : list1[x].menuShow == '1'? true: false,
										component: () => import(`@/views/nav/leftNav`),
										iconCls: list1[x].iconCls,
										meta: {
											apiActiveMenu : list1[x].meta
										},
										leaf: list1[x].leaf == '1'? true: false,
										external: list1[x].external == '1'? true: false,
										children: [
											{
												path : list1[x].path,
												name : list1[x].name,
												menuShow : list1[x].menuShow == '1'? true: false,
												component: () => import(`@/views/nav/rightC`),
										
											}
										],
									}; 
									
							str3.push(temp);
						}
						
						//跳出本次循环
						continue;
					}
					else if(list1[x].children && list1[x].children.length > 0){
						let list2 = list1[x].children;
						
						for(let y = 0; y< list2.length; y++){
							str1 = [];
							
							if(list2[y].children && list2[y].children.length >0){
								let list3 = list2[y].children;
								
								for(let z = 0 ; z < list3.length; z++){
									
									let temp = {
										path : list3[z].path,
										name : list3[z].name,
										menuShow : list3[z].menuShow == '1'? true: false, 
										component: () => import(`@/views${list3[z].component}`),
										meta: {
											apiActiveMenu : list3[z].meta
										},
										leaf: list3[z].leaf == '1'? true: false,
									};
									
									str1.push(temp);
									
								}
																
							}
							
							let temp = {
										path : list2[y].path,
										name : list2[y].name,
										menuShow : list2[y].menuShow == '1'? true: false,
										component: () => import(`@/views${list2[y].component}`),
										children: str1,
										meta: {
											apiActiveMenu : list2[y].meta
										},
										leaf: list2[y].leaf == '1'? true: false,
									}; 
									
							str2.push(temp);
							
						}
												
					}
					
					//不要问我为什么前端这么玩，后端不改，只有前端改，以后会是个天坑					
					if(str2.length>0){//如果上一层leaf是true，这一层的第一个想办法排序为true
						if(!str2[0].menuShow){
							var obj={} ;
							for(var r = 0 ; r< str2.length ;r++){
								if(str2[r].menuShow){//和第一个换位
									obj = str2[r];
									str2[r] = str2[0];
									str2[0] = obj;
									break;
								}
							}	
							
						}
	
					}
					
					let temp = {
										path : list1[x].path,
										name : list1[x].name,
										menuShow : list1[x].menuShow == '1'? true: false,
										component: () => import(`@/views${list1[x].component}`),
										children: str2,
										iconCls: list1[x].iconCls,
										meta: {
											apiActiveMenu : list1[x].meta
										},
										leaf: list1[x].leaf == '1'? true: false,
									}; 
									
					str3.push(temp);
					
				}
				
			}
			
			//拼接的时候，有一个bug,就是在第一层subs中，定义的重定向redirect
			//指定的路径，如果在路由中不存在，需要重新定义值
			let redirect = subs[i].redirect;
			let tag = false;//如果路径在路由中存在true
			
			
			if(!tag){//说明需要设置默认的跳转路径redirect值
				
				if(subs[i].children[0].leaf == "0"){//说明是菜单，需要进入下一层
					if(subs[i].children[0].children[0].leaf == "0"){//说明是菜单，需要进入下一层
						var arr  = subs[i].children[0].children[0];
						
						if(arr.leaf == "0"){
							for(var e = 0 ; e<arr.children.length; e++){
								if(arr.children[e].menuShow == '1' && arr.children[e].leaf == '1'){
					//				console.log(arr.children[e]);
									redirect = arr.children[e].path;
									break;
								}
							}
						}else{
							redirect = arr.path;
						}
						
					}else{
						
						var arr = subs[i].children[0].children;
						for(var t = 0 ;t < arr.length ; t++){
							if(arr[t].menuShow == '1'){
								redirect = arr[t].path;
								break;
							}
						}
					}
				}else{
					redirect = subs[i].children[0].path;
				}
				

			}
			
			console.log(redirect);
			
			let temp = {
					path : subs[i].path,
					name : subs[i].name,
					menuShow : subs[i].menuShow == '1'? true: false,
					component: () => import(`@/views${subs[i].component}`),
					children: str3,
					iconCls: subs[i].iconCls,
					redirect: redirect,
					meta: {
						apiActiveMenu : subs[i].meta
					},
					leaf: subs[i].leaf == '1' ? true: false,
					
				};
				
			str4.push(temp);
				
		}
				
	}
  
  str4.push({
		path: '*',
		component: () => import('@/components/404.vue')
	});
	return str4;

 }


/**
 * routes   要添加的路由
 * 因为addRoutes()会重复添加路由，自定义的方法先去
 * 初始化再添加避免重复添加
 */
export function selfaddRoutes(routes) {
	router.matcher = new Router().matcher;
  router.addRoutes(routes);
}

export function resetTokenAndClearUser() {
  // 退出登陆 清除用户资料
  sessionStorage.clear();
  // 重设路由
  resetRouter()
}


// WEBPACK FOOTER //
// ./src/utils/index.js